import React from "react";
import "../styles/Consumerbanner.css";

import img1 from "../consume-banner/assets/dicorex-tablet/dicorexconsume2.png";
import img2 from "../consume-banner/assets/dicorex-tablet/dicorexconsume1.png";

const DiacorexConsumeSection = () => {
  const steps = [
    {
      img: img1,
      title: "Step 1",
      text: "Take 1 tablet with a glass of lukewarm water",
    },
    {
      img: img2,
      title: "Step 2",
      text: "Take twice daily - once in the morning and once before dinner for optimal blood sugar management",
    },
  ];

  return (
    <section className="consume-banner">
      <h2 className="consume-heading">
        सेवन करने का तरीका (How To Consume)
      </h2>

      <div className="consume-images">
        {steps.map((step, index) => (
          <div className="consume-card" key={index}>
            <img src={step.img} alt={step.title} />
            <h4>{step.title}</h4>
            <p>{step.text}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default DiacorexConsumeSection;
